import React, { FC } from 'react';
import { useFormikContext } from 'formik';
import {
  Label,
  FormItem,
  useFiltersLabel,
  getOptionsWithEmptyOption,
  FiltersNameEnum,
  SizesChildrenCategoryEnum,
  SelectOption,
  FilterDrawerType,
} from '@blocs.filter';
import { RangeSelector } from '../../../shared/components';
import { StyledFormikSelect } from '../../../shared/styles';
import { RangeList, RangeItem } from '../ClothingSizesStyles';
import ClothingSizesChildrenCategory from '../ClothingSizesChildrenCategory';

type Props = {
  type: FilterDrawerType;
  optionsList: { [key: string]: SelectOption[] };
};

const ClothingSizesChildren: FC<Props> = ({ type, optionsList }) => {
  const filtersLabelOfAudience = useFiltersLabel(type);
  const {
    boysSizesOptions,
    girlsSizesOptions,
    toddlersSizesOptions,
    infantsSizesOptions,
    childrenShoeSizeOptions,
    shoeModifierOptions,
  } = optionsList;

  const { values } = useFormikContext();

  const isBoysSizesVisible = values[FiltersNameEnum.sizesChildrenCategory].value === SizesChildrenCategoryEnum.boys;
  const isGirlsSizesVisible = values[FiltersNameEnum.sizesChildrenCategory].value === SizesChildrenCategoryEnum.girls;
  const isToddlersSizesVisible =
    values[FiltersNameEnum.sizesChildrenCategory].value === SizesChildrenCategoryEnum.toddlers;
  const isInfantsSizesVisible =
    values[FiltersNameEnum.sizesChildrenCategory].value === SizesChildrenCategoryEnum.infants;

  return (
    <>
      <FormItem $fullWidth $marginValue={1}>
        <ClothingSizesChildrenCategory
          type={type}
          name={FiltersNameEnum.sizesChildrenCategory}
          label={filtersLabelOfAudience[FiltersNameEnum.sizesChildrenCategory]}
        />
      </FormItem>
      <RangeList>
        {isBoysSizesVisible && (
          <RangeItem>
            <RangeSelector
              saveAsOption
              rangeName={FiltersNameEnum.boys}
              maxName={FiltersNameEnum.max}
              minName={FiltersNameEnum.min}
              label={filtersLabelOfAudience[FiltersNameEnum.boys]}
              options={boysSizesOptions}
            />
          </RangeItem>
        )}
        {isGirlsSizesVisible && (
          <RangeItem>
            <RangeSelector
              saveAsOption
              rangeName={FiltersNameEnum.girls}
              maxName={FiltersNameEnum.max}
              minName={FiltersNameEnum.min}
              label={filtersLabelOfAudience[FiltersNameEnum.girls]}
              options={girlsSizesOptions}
            />
          </RangeItem>
        )}
        {isToddlersSizesVisible && (
          <RangeItem>
            <RangeSelector
              saveAsOption
              rangeName={FiltersNameEnum.toddlers}
              maxName={FiltersNameEnum.max}
              minName={FiltersNameEnum.min}
              label={filtersLabelOfAudience[FiltersNameEnum.toddlers]}
              options={toddlersSizesOptions}
            />
          </RangeItem>
        )}
        {isInfantsSizesVisible && (
          <RangeItem>
            <RangeSelector
              saveAsOption
              rangeName={FiltersNameEnum.infants}
              maxName={FiltersNameEnum.max}
              minName={FiltersNameEnum.min}
              label={filtersLabelOfAudience[FiltersNameEnum.infants]}
              options={infantsSizesOptions}
            />
          </RangeItem>
        )}
        <RangeItem>
          <RangeSelector
            saveAsOption
            rangeName={FiltersNameEnum.childrenShoes}
            maxName={FiltersNameEnum.max}
            minName={FiltersNameEnum.min}
            label={filtersLabelOfAudience[FiltersNameEnum.childrenShoes]}
            options={childrenShoeSizeOptions}
          />
        </RangeItem>
        <RangeItem>
          <Label>{filtersLabelOfAudience[FiltersNameEnum.childrenShoeWidth]}</Label>
          <StyledFormikSelect
            saveAsOption
            name={FiltersNameEnum.childrenShoeWidth}
            size="small"
            options={getOptionsWithEmptyOption(shoeModifierOptions)}
          />
        </RangeItem>
      </RangeList>
    </>
  );
};

export default ClothingSizesChildren;
